
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/data-centers-capabilities",
      function () {
        return require("private-next-pages/expertise/data-centers-capabilities.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/data-centers-capabilities"])
      });
    }
  